import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = { listId: String, listName: String, offset: Number }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    if (this.itemTargets.length === 0) return

    window.pushEcommerceEvent?.({
      event: "view_item_list",
      ecommerce: {
        item_list_id: this.listIdValue,
        item_list_name: this.listNameValue,
        items: this.itemTargets.map((item, index) => ({
          ...JSON.parse(item.dataset.analytics),
          index: this.offsetValue + index,
        })),
      },
    })
  }
}
